import { gsap, ScrollTrigger, ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
import { scrollBar } from "../utils/scrollBar";
import { revealAnimations } from "./animations-reveal";

const onscrollAnimations = () => {
  const isMobile = window.innerWidth <= 1024;
  if (isMobile) return;

  const sections = [...document.querySelectorAll("section")];
  const invertedSections = sections.filter((s) => s.dataset.inverted);
  const header = document.querySelector("header");
  const headerOffset = header.clientHeight / 2;
  const footer = document.querySelector("footer");
  const aside = document.querySelector("aside");
  const asideNum = aside.querySelector(".active");
  const asideNumOffset = asideNum.getBoundingClientRect();
  const scrollButton = document.querySelectorAll(".scroll_btn");

  let activeIdx = 0;
  let visibleIdx;
  let scrollDirection;
  let scrollBack = false;

  // Main scrollbar
  const mainScrollBar = new scrollBar({
    draggable: true,
    smoothScroll: true
  });

  // mainScrollBar.scrollTo(0);
  // window.scrollTo(0, 0);
  // document.body.scrollIntoView();

  const scrollingChidren = [...document.querySelectorAll('[data-scrolling]')];

  // scrollingChidren.length && scrollingChidren.forEach(el => {

  //   let scrollingDiv = new scrollBar({
  //     scroller: el,
  //     draggable: true,
  //     // smoothScroll: true
  //   });

  //   // el.addEventListener('wheel', () => {
  //   //   console.log('Wheel');
  //   //   mainScrollBar.pause();
  //   // });
  //   // el.addEventListener('mouseenter', () => {
  //   //   mainScrollBar.pause();
  //   //   // mainScrollBar.scrollInside(el);
  //   //   // el.onwheel = (e) => {
  //   //   //   console.log(e);
  //   //   // }
  //   // });
  //   // el.addEventListener('mouseleave', () => {
  //   //   mainScrollBar.start();
  //   // });
  // });

  // Invert on scroll
  const toggleInvert = (section) => {

    // Invert header
    ScrollTrigger.create({
      trigger: section,
      start: `top ${headerOffset}px`,
      end: `bottom ${headerOffset}px`,
      onToggle: (e) => header.classList.toggle("inverted", e.isActive),
    });
  };

  // Sidebar navigation
  const sectionsNavAside = () => {

    // Hide navigation if only 1 section
    if (sections.length < 2) {
      aside.classList.add("hidden");
      return;
    }

    const nums = aside;
    const activeNum = nums.querySelector(".active");
    const allNums = nums.querySelector(".all");

    allNums.textContent = sections.length < 10 ? `0${sections.length}` : sections.length;

    const toggleActiveIdx = () => {
      visibleIdx = activeIdx + 1 < 10 ? `0${activeIdx + 1}` : activeIdx + 1;

      gsap
        .timeline()
        .to(activeNum, {
          duration: 0.2,
          autoAlpha: 0,
          xPercent: 100 * scrollDirection,
        })
        .set(activeNum, { xPercent: -100 * scrollDirection })
        .call(() => (activeNum.textContent = visibleIdx))
        .to(activeNum, { duration: 0.2, xPercent: 0, autoAlpha: 1 });
    };

    sections.forEach((s, idx) => {
      ScrollTrigger.create({
        trigger: s,
        start: `top ${asideNumOffset.bottom}px`,
        end: `bottom ${asideNumOffset.bottom}px`,
        // markers: true,
        onUpdate(e) {
          scrollDirection = e.direction;
        },
        onToggle(e) {
          if (e.isActive) {
            asideNum.classList.toggle(
              "inverted",
              s.dataset.inverted === "true"
            );
            activeIdx = idx;
            toggleActiveIdx();
          }
        },
      });
    });

  };

  // Scroll on click scrollButton
  const clickScrollButton = () => {
    const scrollTo = (idx) => {
      gsap.to(window, { duration: 0.75, scrollTo: sections[idx] });
    };

    scrollButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.contains("top") && scrollTo(0);
        button.classList.contains("bottom") && scrollTo(1);
      });
    });
  };

  const hideOnFooter = () => {

    const tl = gsap.timeline({ paused: true })
      .to(header, { duration: 0.3, yPercent: -100 });

    ScrollTrigger.create({
      trigger: sections[sections.length - 1],
      start: `bottom ${asideNumOffset.bottom}px`,
      // markers: true,
      onToggle(e) {

        scrollBack = e.isActive;
        // Hide aside navigation on footer
        if (sections.length > 1) {
          aside.classList.toggle("hidden", e.isActive);
        }
        // Hide header on footer
        if (e.isActive) {
          tl.play()
        } else {
          tl.reverse();
        }
      }
    });

  }

  const toggleHeader = () => {

    ScrollTrigger.create({
      // markers: true,
      start: 'top -50',
      end: `+=${document.body.scrollHeight}px`,
      toggleClass: { className: 'scrolling', targets: header }
    });
  }

  const pinScrollingSections = () => {

    const pinned = ['.page-template-page-plans .prices_plans'];

    pinned.forEach(s => {
      let section = document.querySelector(s);
      if (!section) return;

      let scroller = section.querySelector('[data-scroller]');
      let scrollHeight = scroller.scrollHeight * 0.75;
      // let overScroll = scrollHeight + section.clientHeight;

      ScrollTrigger.create({
        trigger: s,
        pin: true,
        // markers: true,
        start: "top top",
        // pinSpacing: false,
        end: () => `+=${scrollHeight}px`,
        onUpdate(e) {
          let offset = scrollHeight * e.progress.toFixed(2);
          gsap.to(scroller, { scrollTo: offset, ease: "none" });
        }
      });
    })
  }

  toggleHeader();
  pinScrollingSections();
  hideOnFooter();
  revealAnimations();
  invertedSections.length && invertedSections.forEach((s) => toggleInvert(s));

  gsap.matchMedia(document.body).add("(min-width: 1024px)", (context) => {
    scrollButton.length && clickScrollButton();
    sectionsNavAside();
  });

};

export { onscrollAnimations }
